import { useTranslation } from 'react-i18next';
import { IFormInstance, useWatchForm } from '@/components';
import { useGetRequiredRule } from '@/hooks';
import { SyncFormFormFields, SyncType } from '../helpers';

export const useSyncFormRules = (form: IFormInstance) => {
  const { t } = useTranslation();
  const required = useGetRequiredRule({ t });
  const syncType = useWatchForm(SyncFormFormFields.TYPE, form);
  const isSpecificProductSync = syncType === SyncType.SPECIFIC_PRODUCT;

  return {
    [SyncFormFormFields.CHANNEL]: isSpecificProductSync ? [required] : [],
    [SyncFormFormFields.CHANNEL_SLUGS]: isSpecificProductSync ? [] : [required],
    [SyncFormFormFields.TYPE]: [required],
    [SyncFormFormFields.SKU]: isSpecificProductSync ? [required] : [],
    [SyncFormFormFields.UPDATED_FROM]: isSpecificProductSync ? [] : [required],
    [SyncFormFormFields.UPDATED_UNTIL]: isSpecificProductSync ? [] : [required],
  };
};
